import DeseaCancelar from "./DeseaCancelar"; 
import { ModalCambiarUnion } from "./ModalCambiarUnion";
import ModalPerfil from "./ModalPerfil";

export const AdminUserModals = ({
    perfil,
    evaluarUsuario,
    idElemSeleccionado,
    modificarMora, 
    cambiarUnion
}) => (
    <>
        <ModalPerfil perfil={perfil} modificarMora={modificarMora} evaluarUsuario={evaluarUsuario} esAdmin />

        <ModalCambiarUnion perfil={perfil} cambiarUnion={cambiarUnion}/>

        <DeseaCancelar
            funcionAdmin={() => evaluarUsuario(idElemSeleccionado, false)}
            id="desaprobarUsuario"
        />
    </>
);
